<template>
    <BaseCounterCardForm
        :value="widgetLayoutModel"
        :widget-config="widgetConfig"
        :template-id="templateId"
        type-property-name="voicebotType"
        type-label-key="voicebot.counter.type"
        :type-options="availableTypesOptions"
        :types-config="typesConfig"
        @input="onLayoutUpdate"
        @update:config="updateFilterItem"
    />
</template>

<script setup lang="ts">
import { WidgetConfig, WidgetLayout } from '@/types/dashboard'
import { computed } from 'vue'
import { voicebotTypeNamesMapped, voicebotTypes } from '@/enum/voicebotCounters'
import BaseCounterCardForm from '@/components/RedesignComponents/Widgets/Edit/WidgetCardsForms/BaseCounterCardForm.vue'

interface IProps {
    value: WidgetLayout
    widgetConfig: WidgetConfig[]
    templateId: number
}

const props = defineProps<IProps>()
const emit = defineEmits<{
    (e: 'input', pl: WidgetLayout): void
    (e: 'update:config', pl: WidgetConfig): void
}>()

const widgetLayoutModel = computed(() => props.value)

const availableTypesOptions = computed(() => {
    return voicebotTypeNamesMapped()
})

const typesConfig = voicebotTypes

function onLayoutUpdate (layout: WidgetLayout) {
    emit('input', layout)
}

function updateFilterItem (filterData: WidgetConfig) {
    emit('update:config', filterData)
}
</script>
